:host {
  .iframe {
    margin-right: -1px;
    margin-left: -1px;

    &__wrapper {
      overflow: auto;
      -webkit-overflow-scrolling: touch;

      iframe {
        width: 1px;
        min-width: 100%;
        border: none;
      }
    }

    &__hiddentext {
      display: none;
    }

    &--hidden {
      .iframe {
        &__wrapper {
          display: none;

          @include breakpoint($small) {
            display: block;
          }
        }

        &__hiddentext {
          display: block;

          @include breakpoint($small) {
            display: none;
          }
        }

        &__element {
          display: none;

          @include breakpoint($small) {
            display: block;
          }
        }
      }
    }
  }
}
